import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConversationId } from '../libraries/conversation-id';
import { RequestExecutor } from '../libraries/request-executor';
import { Constants } from '../constants';
import { merge } from 'lodash';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class LoggerService extends RequestExecutor {

    /**
     * Class constructor
     * @param _conversationId
     * @param _httpClient Local instance of HTTP Client
     */
    constructor(
        protected _conversationId: ConversationId,
        protected _httpClient: HttpClient
    ) {
        super(_conversationId, _httpClient);
    }

    /**
     * Sets the current request headers
     *
     * @param requestHeaders
     * @returns {LoggerService}
     */
    public setRequestHeaders(requestHeaders?: object): LoggerService {
        super.setRequestHeaders(requestHeaders || {});

        return this;
    }

    /**
     * Sets the current request body
     *
     * @param requestBody
     * @returns {LoggerService}
     */
    public setRequestBody(requestBody?: object): LoggerService {
        super.setRequestBody(requestBody || {});

        return this;
    }


    public logError(message, optionalDetails = {}) {
        this.logToSplunk('error', message, optionalDetails)
            .then((result: any) => {
                return result;
            })
            .catch((err) => {
                return err;
            });
    }

    public logInfo(message, optionalDetails = {}) {
        this.logToSplunk('info', message, optionalDetails)
            .then((result: any) => {
                return result;
            })
            .catch((err) => {
                return err;
            });
    }

    /**
     * @desc Log data to server
     * @param logData
     * 
     */
    public logToSplunk(logLevel = 'error', message: string, optionalDetails = {}): Promise<any> {
        const logData = merge(
            {},
            {
            logLevel,
            message
            },
            optionalDetails
        );

        return new Promise((resolve, reject) => {
            this.setRequestBody(logData)
            .executeRequest(
                Constants.REQUEST_TYPE_POST,
                `${environment.apiConfiguration.basePath}${environment.apiConfiguration.paths.logger}`
            )
            .subscribe(
                (result: any) => {
                    resolve(result);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }
}
